import { FC, ReactNode, useState } from 'react';
import { useRelatorios } from '@/hooks/useRelatorios';
import RelatoriosMenu from './RelatoriosMenu';

interface Props {
  children: ReactNode;
}

/**
 * Moldura da área de relatórios: menu lateral fixo + conteúdo.
 *
 * Entrou no lugar das abas que ficavam no topo do painel da Equiplex — com mais de
 * um cliente e mais de uma frente na lista, a faixa de abas não escalava. No mobile
 * o menu vira uma gaveta que abre por um botão no fluxo da página; um segundo botão
 * flutuante brigaria com o hambúrguer do menu principal do app.
 */
const RelatoriosLayout: FC<Props> = ({ children }) => {
  const { grupos } = useRelatorios();
  const [aberto, setAberto] = useState(false);

  // `grow`, não `min-h-full`: o <main> do AppLayout é coluna flex com o rodapé embaixo. A altura em
  // % resolve contra o main já esticado, a moldura fica com a altura toda, empurra o rodapé para
  // fora e o main ganha a própria barra de rolagem, ao lado da da página (30/10/2026).
  return (
    <div className="flex grow flex-col lg:flex-row">
      <aside className="shrink-0 border-b border-theme-border lg:w-64 lg:border-b-0 lg:border-r">
        <div className="flex items-center justify-between gap-2 px-4 py-3 lg:px-4 lg:py-6">
          <p className="text-xs font-semibold uppercase tracking-wide text-content-muted">Relatórios</p>
          <button
            type="button"
            onClick={() => setAberto((v) => !v)}
            aria-expanded={aberto}
            aria-controls="menu-relatorios"
            data-testid="relatorios-menu-toggle"
            className="inline-flex items-center gap-1 rounded-lg border border-theme-border px-2.5 py-1 text-xs text-content-secondary lg:hidden"
          >
            <span aria-hidden className="material-symbols-outlined text-[16px] leading-none">
              {aberto ? 'close' : 'menu'}
            </span>
            {aberto ? 'Fechar' : 'Trocar'}
          </button>
        </div>
        <div
          id="menu-relatorios"
          className={`px-2 pb-4 lg:block lg:px-2 ${aberto ? 'block' : 'hidden'}`}
        >
          <RelatoriosMenu grupos={grupos} onNavegar={() => setAberto(false)} />
        </div>
      </aside>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
};

export default RelatoriosLayout;
